var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about container"},[_c('section',{staticClass:"container-flex"},[_c('h1',[_vm._v(" About Marc Wilk ")]),_c('div',{staticClass:"img-container"},[_c('progressive-img',{attrs:{"src":_vm.marc,"title":"Marc","alt":"Marc Wilk Self Photo"}})],1),_c('div',{staticClass:"copy",domProps:{"innerHTML":_vm._s(_vm.about)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }